module.exports = {
  siteTitle: "Bâtiment en transitions",
  siteTitleAlt: "BeT", // This allows an alternative site title for SEO schema.
  publisher: "Bâtiment en transitions", // Organization name used for SEO schema
  siteDescription: "Bâtiments en Transition est une entreprise de maîtrise d'oeuvre éco-responsable spécialisée dans la rénovation énergétique et écologique.",
  siteKeyWords: "maîtrise d'ouvrage,écologie,rénovation,toulouse,france",
  siteUrl: "https://batiments-en-transition.fr", // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  siteLanguage: "fr",
  author: "Arthur Beretta", // Author for RSS author segment and SEO schema
  authorUrl: "https://github.com/FroxThur", // URL used for author and publisher schema, can be a social profile or other personal site
  shortTitle: "BeT", // Used for App manifest e.g. Mobile Home Screen
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 1200, // Change to the height of your default share image
  siteLogo: "/logos/logo.png", // Logo used for SEO, RSS, and App manifest
  backgroundColor: "#e9e9e9", // Used for Offline Manifest
  themeColor: "#155131", // Used for Offline Manifest
};
